import { TrashIcon } from "@heroicons/react/24/outline";
import ConfirmModal from "../../shared/Confirm/ConfirmModal";
import { useState } from "react";
import usePriceSettingsMutations from "../../../data/usePriceSettingsMutations";

export default function SpecificPriceActions({ info }: { info: any }) {
  const [isOpen, setIsOpen] = useState(false);
  const { removeSpecific } = usePriceSettingsMutations();

  return (
    <div className="px-3 flex justify-center space-x-4">
      <ConfirmModal
        open={isOpen}
        setOpen={setIsOpen}
        title="Delete Specific Price Setting"
        message="Are you sure you want to delete this specific price setting? This action cannot be undone."
        confirmButtonText="Delete"
        onConfirm={() => {
          setIsOpen(false);
          removeSpecific.mutate(info.row.original.id, {});
        }}
        isLoading={false}
      />
      <TrashIcon
        className={`w-4 h-4 text-gray-600 hover:text-primary-600 hover:scale-110 transition-all duration-200`}
        onClick={(e: any) => {
          e.stopPropagation();
          setIsOpen(true);
        }}
      />
    </div>
  )
}